var fonts = {
  body: 'Arial, Helvetica, sans-serif',
  heading: 'Arial, Helvetica, sans-serif',
  monospace: 'Menlo, monospace'
};
export default fonts;